import { EditorView } from 'codemirror';
import { parseDocument as yamlParse } from 'yaml';
import { linter } from '@codemirror/lint';

type Severity = 'hint' | 'info' | 'warning' | 'error';

/**
 * Parse a YAML error provided by the `yaml` library into a CodeMirror Diagnostic format.
 * @param errors list of errors provided by the `yaml` library
 * @param level the severity level to assign to these errors (e.g., 'error' or 'warning')
 * @returns an array of CodeMirror Diagnostic objects
 */
const parseSyntaxErrors = (errors: any[], level: Severity) => {
  return errors.map((err) => ({
    from: err.pos?.[0] ?? 0,
    to: err.pos?.[1] ?? err.pos?.[0] ?? 0,
    message: err.message,
    severity: level,
    source: 'yaml-syntax',
  }));
};

/**
 * A CodeMirror linter extension for YAML files.
 * It parses the YAML content and returns diagnostics for any syntax errors or warnings.
 */
export const yamlLinter = linter(
  (view: EditorView) => {
    try {
      const yamlDoc = yamlParse(view.state.doc.toString());
      return [...parseSyntaxErrors(yamlDoc.errors, 'error'), ...parseSyntaxErrors(yamlDoc.warnings, 'warning')];
    } catch (e: any) {
      return parseSyntaxErrors([e], 'error');
    }
  },
  { autoPanel: true },
);

// Define the styles in JS
export const codeMirrorErrorTheme = EditorView.theme({
  '.cm-gutter-lint': {
    /* Move it to the start (default is 0, so -1 puts it first) */
    order: -1,
  },
});
